import React, { useState } from "react";
import { db } from "../firebase";
import {
  collection,
  doc,
  setDoc,
  serverTimestamp,
  query,
  orderBy,
  limit,
  getDocs,
} from "firebase/firestore";
import { X, Send, Sparkles } from "lucide-react";

export default function MySpaceSubmitForm({ onClose }) {
  const [form, setForm] = useState({
    title: "",
    author: "",
    college: "",
    full: "",
    type: "",
    customType: "",
    email: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async () => {
    if (!form.title || !form.author || !form.college || !form.full || !form.type || !form.email) {
      alert("Please fill all required fields");
      return;
    }

    if (form.type === "other" && !form.customType.trim()) {
      alert("Please specify the type");
      return;
    }

    setLoading(true);

    try {
      // 🔢 Get last number
      const q = query(
        collection(db, "myspacerequests"),
        orderBy("number", "desc"),
        limit(1)
      );

      const snap = await getDocs(q);
      let nextNumber = 1;

      if (!snap.empty) {
        nextNumber = snap.docs[0].data().number + 1;
      }

      const finalType = form.type === "other" ? form.customType : form.type;
      const shortDesc =
        form.full.substring(0, 200) + (form.full.length > 200 ? "..." : "");

      // ✅ number used as document ID
      await setDoc(doc(db, "myspacerequests", String(nextNumber)), {
        number: nextNumber,
        title: form.title,
        author: form.author,
        email: form.email,
        full: form.full,
        short: shortDesc,
        type: finalType,
        college: form.college,
        published: false,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });

      setSuccess(true);

      setTimeout(() => {
        setForm({
          title: "",
          author: "",
          college: "",
          full: "",
          type: "",
          customType: "",
          email: "",
        });
        setSuccess(false);
        if (onClose) onClose();
      }, 2000);

    } catch (error) {
      console.error(error);
      alert("Submission failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed font-blinker inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl">

        <div className="bg-black text-white p-6 rounded-t-2xl flex justify-between">
          <div>
            <h2 className="text-3xl font-bold flex items-center gap-2">
              <Sparkles size={28} />
              Share Your Writing
            </h2>
            <p className="text-gray-300 mt-1">Submit your work to MySpace</p>
          </div>
          <button onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        {success && (
          <div className="m-6 bg-green-50 border-2 border-green-500 p-4 rounded-xl text-green-800">
            🎉 Submission successful!
          </div>
        )}

        <div className="p-6 space-y-5 max-h-[70vh] overflow-y-auto">

          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Email *"
            className="w-full p-3 border-2 rounded-lg"
          />

          <input
            type="text"
            name="author"
            value={form.author}
            onChange={handleChange}
            placeholder="Full name *"
            className="w-full p-3 border-2 rounded-lg"
          />

          <input
            type="text"
            name="college"
            value={form.college}
            onChange={handleChange}
            placeholder="College *"
            className="w-full p-3 border-2 rounded-lg"
          />

          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleChange}
            placeholder="Title *"
            className="w-full p-3 border-2 rounded-lg"
          />

          <select
            name="type"
            value={form.type}
            onChange={handleChange}
            className="w-full p-3 border-2 rounded-lg"
          >
            <option value="">Select type *</option>
            <option value="poem">Poem</option>
            <option value="story">Story</option>
            <option value="article">Article</option>
            <option value="other">Other</option>
          </select>

          {form.type === "other" && (
            <input
              type="text"
              name="customType"
              value={form.customType}
              onChange={handleChange}
              placeholder="Specify type"
              className="w-full p-3 border-2 rounded-lg"
            />
          )}

          <textarea
            name="full"
            value={form.full}
            onChange={handleChange}
            rows={12}
            placeholder="Your writing *"
            className="w-full p-3 border-2 rounded-lg resize-none"
          />

          <p className="text-xs text-gray-500">
            {form.full.trim() === "" ? 0 : form.full.trim().split(/\s+/).length} words
          </p>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className="w-full bg-black text-white py-4 rounded-xl font-bold"
          >
            {loading ? "Submitting..." : "Submit"}
          </button>

        </div>
      </div>
    </div>
  );
}
